import React from 'react';
import ReactTooltip  from 'react-tooltip';

import Select from 'react-select';
import 'react-select/dist/react-select.css';

export default class DependentChildren extends React.Component {
    constructor(props) {
        super(props);

        const categoryOptions = [
            {
                value: '',
                label: 'None of the Categories Below'
            },
            {
                value: 'underage',
                label: 'Under 18 or In Education'
            },
            {
                value: 'inEducation',
                label: 'Over 18 - In Education (Diploma level)'
            },
            {
                value: 'inHigherEducation',
                label: 'Over 18 - In Education (Degree level or higher)'
            },
            {
                value: 'disabled',
                label: 'Disabled'
            },
            {
                value: 'disabledInEducation',
                label: 'Disabled - In Higher Education'
            }
        ];

        const pcbDeductionOptions = [
            {
                value: '0',
                label: '0%'
            },
            {
                value: '50',
                label: '50%'
            },
            {
                value: '100',
                label: '100%'
            }
        ]

        this.state = {
            children: props.children,
            categoryOptions,
            pcbDeductionOptions
        };
    }

    componentDidUpdate() {
        ReactTooltip.rebuild();
    }

    componentWillReceiveProps(props) {
        this.setState(Object.assign({},
            this.state,
            {
                children: props.children
            }
        ));
    }

    handleChange = (type, id, value) => {
        const child = this.state.children.find(c =>
            c.id === id);

        child[type] = value;

        if (this.props.onChange) {
            this.props.onChange(this.state.children);
        }
    }

    render() {
        const { children, categoryOptions, pcbDeductionOptions } = this.state;

        if (!children || children.length === 0) return null;

        return (
            <div className='row'>
                <div className='col-lg-12 col-xl-8'>
                    <label>
                        Provide details about the children and PCB Deduction for Dependent Children <i
                            className="fa fa-question-circle"
                            data-tip="See help article for more info:
                                <a href='http://help.payrollpanda.my/12465-malaysia-payroll-faq/what-tax-deductions-am-i-allowed-to-claim-for-my-kids?' target='_blank'>
                                    What tax deductions am I allowed to claim for my children?
                                </a>"

                        ></i>
                    </label>

                    {children &&
                        children.map((child, i) => (
                            <div className='row children' key={i}>
                                <div className='col-sm-12 col-md-3 order'>
                                    {(i + 1) + ((i + 1) === 1 ?
                                        'st' : (i + 1) === 2 ?
                                            'nd' : (i + 1) === 3 ?
                                                'rd': 'th') + ' Child'}
                                </div>

                                <div className='col-sm-12 col-md-6'>
                                    <div className='pcb-select'>
                                        <Select
                                            name='category'
                                            value={child.category}
                                            onChange={category =>
                                                this.handleChange(
                                                    'category',
                                                    child.id,
                                                    category ?
                                                        category.value : ''
                                                )
                                            }
                                            options={categoryOptions}
                                            searchable={false}
                                            clearable={false}
                                        />
                                    </div>
                                </div>

                                <div className='col-sm-12 col-md-3'>
                                    <div className='pcb-select'>
                                        <Select
                                            name='pcbDeduction'
                                            value={child.pcbDeduction}
                                            onChange={pcbDeduction =>
                                                this.handleChange(
                                                    'pcbDeduction',
                                                    child.id,
                                                    pcbDeduction ?
                                                        pcbDeduction.value : ''
                                                )
                                            }
                                            options={pcbDeductionOptions}
                                            searchable={false}
                                            clearable={false}
                                        />
                                    </div>
                                </div>
                            </div>
                        ))
                    }
                </div>
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/components/Calculator/DependentChildren/Details.js